module.exports = __webpack_public_path__ + "static/media/arxontisa-bg-cover.84524fc4.jpg";